import { AuthenticationService } from 'src/app/core/services/auth.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemParams, DgColumnDataType, DgColumnWidths, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { firstValueFrom } from 'rxjs';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { SimNetworkEventEmbeddedComponent } from '../sim-network-event/sim-network-event.component';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';


const apiPath             =environment.eSimApi+eSimApiPaths.Webbing;
const exportFilenameSuffix="Network-Events-Data";
const popUpTitle          ="Network Event";

@Component({
  selector: 'app-sim-network-events-embedded',
  templateUrl: './sim-network-events.component.html',
  styleUrls: ['./sim-network-events.component.scss']
})

export class SimNetworkEventsEmbeddedComponent implements OnInit {
  
  @Input() iccid           : string  | undefined;
  @Input() locationLicensed: boolean | undefined;
  @Input() orderid         : number  | undefined;
  
  @ViewChild('gridView',       { static: false }) gridView!       : GridViewComponent;
  @ViewChild('simNetworkEvent'                  ) simNetworkEvent!: SimNetworkEventEmbeddedComponent;
  
  private alignmentReloadDone: boolean=false;
  private gridViewDefaults!  : GridViewDefaults;
  
  public curUser           : SystemUserDTO;
  public dgApiPath!        : DgApiPath | undefined;
  public dgActionColumn!   : DgActionColumn | undefined;
  public dgColumns!        : Array<DgColumn>;
  public dgPopup!          : DgPopup | undefined;
  public dgProperties!     : DgProperties | undefined;
  public endDate           : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public gridHasBeenClicked: boolean=false; //CRN_20250203 - Need to know when the grid has been clicked more than once for all the fields to be drawn in the child (SimNetworkEventEmbeddedComponent)
  public gridViewRowId     : number | undefined;
  public gotDgProperties   : boolean=false;
  public startDate         : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  
  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService,
    private gridViewService           : GridViewService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      if (this.iccid == undefined) {
        throw new Error("SimNetworkEventsEmbeddedComponent - ICCID cannot be determined");
      }

      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(apiPath);
      this.dgApiPath!.refreshGet=() => this.setDgApiPathGet(false);

      await this.setDgApiPathGet(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn         =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.visible=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup=this.gridViewDefaults.setUpDgPopup(popUpTitle);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      this.dgProperties                     =this.gridViewDefaults.setUpDgProperties("", exportFilenameSuffix + "-" + this.iccid);
      this.dgProperties!.focusedRowUnselect =false;
      this.dgProperties!.gridKey           ="EmbeddedSimNetworkEvents";
      this.dgProperties!.masterDetail       =true;
      this.dgProperties!.showAddButton      =false;
      this.dgProperties!.showRefreshButton  =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];

      //Type
      dgColumn=this.gridViewDefaults.setUpDgColumn("Type", "Type", "", DgColumnDataType.string);
      dgColumn!.width=170;
      this.dgColumns.push(dgColumn!);

      //Status
      dgColumn       =this.gridViewDefaults.setUpDgColumn("Status", "Status", "", DgColumnDataType.string);
      dgColumn!.width=130;
      this.dgColumns.push(dgColumn!);

      //SubStatus
      dgColumn             =this.gridViewDefaults.setUpDgColumn("SubStatus", "Sub Status", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //ICCID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("ICCID", "ICCID", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //IMSI
      dgColumn=this.gridViewDefaults.setUpDgColumn("IMSI", "IMSI", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //AssignedIP
      dgColumn=this.gridViewDefaults.setUpDgColumn("AssignedIP", "IP", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //SubscriberIP
      dgColumn=this.gridViewDefaults.setUpDgColumn("SubscriberIP", "IP", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //MCCMNC
      dgColumn=this.gridViewDefaults.setUpDgColumn("MCCMNC", "MCCMNC", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      // CountryFlag	
      dgColumn            =this.gridViewDefaults.setUpDgColumn("CountryFlag", "Country Flag", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      dgColumn!.allowSearch=false;
      this.dgColumns.push(dgColumn!);

      // Country	
      dgColumn                  =this.gridViewDefaults.setUpDgColumn("Country", "Country", "", DgColumnDataType.string);
      dgColumn!.width           =170;
      dgColumn!.cellTemplate    ="CountryTemplate";
      dgColumn!.cellTemplateType="imageAndValue"
      dgColumn!.imageColumn     ="CountryFlag" 
      this.dgColumns.push(dgColumn!);

      //VPLMN
      dgColumn=this.gridViewDefaults.setUpDgColumn("VPLMN", "VPLMN", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //APN
      dgColumn=this.gridViewDefaults.setUpDgColumn("APN", "APN", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //SD
      dgColumn=this.gridViewDefaults.setUpDgColumn("SD", "SD", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //Product
      dgColumn=this.gridViewDefaults.setUpDgColumn("Product", "Product", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //EventDate
      dgColumn       =this.gridViewDefaults.setUpDgColumn("EventDate", "Event Date", "", DgColumnDataType.datetime);
      dgColumn!.width=150;
      this.dgColumns.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onGridContentReady(): void {
    try {
      //RBW_20260611 - A fresh DevExtreme master-detail grid renders its fixed-column and main-table rows 1px out of sync, drifting the expand
      //               arrows further out the further down the grid you go. So after the first data has loaded, reassign the client-side data to a fresh copy of itself - same
      //               data, new reference, no extra server call - to trigger that aligned rebuild. Guarded so it only runs once.
      if (this.alignmentReloadDone || !this.gridView?.clientSideProcessingModels?.length)
        return;

      this.alignmentReloadDone=true;

      this.gridView.clientSideProcessingModels=[...this.gridView.clientSideProcessingModels];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridAddButtonClick(e:any) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridEditButtonClick(e:any) {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridRowExpanding(e:any) {
    try {
      const networkEvent                     =this.gridView.clientSideProcessingModels?.find(x => x.id == e);

      this.gridViewRowId                     =e;
      this.simNetworkEvent.gridHasBeenClicked=this.gridHasBeenClicked; //false the first time clicked
      this.gridHasBeenClicked                =true;
      this.simNetworkEvent.showNetworkEvent(networkEvent);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async startDateChanged(startDate: OurDate): Promise<void> {
    try {
      this.startDate=startDate;

      await this.setDgApiPathGet(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async endDateChanged(endDate: OurDate): Promise<void> {
    try {
      this.endDate=endDate;

      await this.setDgApiPathGet(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async setDgApiPathGet(refreshGrid: boolean): Promise<void> {
    try {
      if (this.iccid == undefined)
        throw new Error("SimNetworkEventsEmbeddedComponent - ICCID cannot be determined");

      const iccidToEncrypt=<string>this.iccid;
      const iccidEncResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(iccidToEncrypt, true));
      const iccidEncSS    =iccidEncResult.result;

      this.dgApiPath!.get=environment.eSimApi +
                          eSimApiPaths.Webbing + '/' +
                          eSimApiPaths.WebbingGetNetworkEventsBySimAndDate +
                          "?iccidEncSS=" + iccidEncSS +
                          "&orderid=" + this.orderid +
                          `&eventstartdate=${this.startDate?.year ?? 1}-${this.startDate?.month ?? 1}-${this.startDate?.day ?? 1}` +
                          `&eventenddate=${this.endDate?.year ?? 1}-${this.endDate?.month ?? 1}-${this.endDate?.day ?? 1}`;

      if (refreshGrid) {
        this.gridViewService.apiPathGet=this.dgApiPath!.get;
        this.gridView.refreshData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
